import FilesApi from "../Api/Services/AppflyteBackend/FileServiceApi";
const appflyte_s3_bucket = window.__ENV__.S3_BUCKET_NAME

// const uploadFile = async (blob, reqBody) => {
//     try {
//         const resData = await FilesApi.getUploadURLByPath(JSON.stringify(reqBody))
//         if (resData.status === 200) {
//             const urlFields = JSON.parse(resData.data.url_fields)
//             let formData = new FormData();

//             formData.append('key', urlFields.key);
//             formData.append('AWSAccessKeyId', urlFields.AWSAccessKeyId);
//             formData.append('policy', urlFields.policy);
//             formData.append('signature', urlFields.signature);
//             formData.append('file', blob);

//             const resUpload = await FilesApi.uploadFile(resData.data.url, formData)
//             if (resUpload.status === 200 || resUpload.status === 204) {
//                 return resData?.data?.file_id
//             }
//             return null
//         }
//         return null
//     } catch (e) {
//         console.log('Err ' + e)
//         return null
//     }
// }

const uploadFile = async (blob, reqBody) => {
    try {
        const resData = await FilesApi.getUploadURLByPath(JSON.stringify(reqBody))
        if (resData.status === 200) {
            const urlFields = JSON.parse(resData.data.url_fields)
            const formData = new FormData();

            // Append every field returned by the server, exactly as given.
            // Works for both Signature V2 and V4 (x-amz-credential, x-amz-signature, etc.)
            Object.entries(urlFields).forEach(([key, value]) => {
                formData.append(key, value);
            });

            // file MUST be appended last — S3/MinIO ignores anything after it
            formData.append('file', blob);

            const resUpload = await FilesApi.uploadFile(resData.data.url, formData)
            if (resUpload.status === 200 || resUpload.status === 204) {
                return resData?.data?.file_id
            }
            return null
        }
        return null
    } catch (e) {
        console.log('Err ' + e)
        return null
    }
}


const uploadAndAppendForPost = async (filename, file) => {
    try {
        const reqBodyFile = {
            file_context: 'file_upload',
            content_type: filename?.split('.')[1],
            file_type: 'json',
            file_name: filename,
            bucket_name: appflyte_s3_bucket
        }

        const uploadedFileId = await uploadFile(file, reqBodyFile)
        if (uploadedFileId) {
            const uploadedFileUrl = await FilesApi.getUploadedFileUrls(uploadedFileId)
            if (uploadedFileUrl.status === 200) {
                return { fileId: uploadedFileId, fileUrl: uploadedFileUrl?.data?.[0]?.download_url }
            }
            return { fileId: null, fileUrl: null }
        }
        return { fileId: null, fileUrl: null }
    }
    catch (err) {
        console.log("ERROR: ", err);
        return { fileId: null, fileUrl: null }
    }
}

const handleFileUpload = async (filename, file) => {
    try {
        const uploadResponse = await uploadAndAppendForPost(filename, file);

        if (uploadResponse.fileUrl && uploadResponse.fileId) {
            return {
                status: 200,
                fileUrl: uploadResponse.fileUrl,
                fileId: uploadResponse.fileId,
                fileName: filename
            };
        }
        return { status: 404 };
    } catch (err) {
        console.log("ERROR: ", err);
        return { status: 404 };
    }
};
export default handleFileUpload;
